import { render, staticRenderFns } from "./InputHolder.vue?vue&type=template&id=94fac80c"
import script from "./InputHolder.vue?vue&type=script&lang=js"
export * from "./InputHolder.vue?vue&type=script&lang=js"
import style0 from "./InputHolder.vue?vue&type=style&index=0&id=94fac80c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports